import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Tree for Two",
  "description": "",
  "published": "2007-04-12T00:00:00.000Z",
  "redirect_from": ["/blog/tree-for-two/swizec/233"],
  "categories": "linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Often with student films of all kind the product is a bit lacking in many frontiers. Usually these can be acredited to low budgets and young people with little experience. I've sat through a showing of several student films once or twice in my life and the programme was two hours long, by the end of which I thought I would poke my eyes out rather than suffer onward.`}</p>
    <p>{`Then sometimes you get things like what Joel Furtado created in `}<a parentName="p" {...{
        "href": "http://joelfurtado.com/"
      }}>{`Tree for two`}</a>{`. He claims the 6 minute 3D animated short took eight months to produce from concept to finish and I think it was totally worth it. The movements are so natural you almsot forget it's not done with modern animation techoniliges utilised by hollywood; the only exeption to the rule seems to be the dog's lower jaw, which just looks a bit odd.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      